<template>
  <v-dialog
    :value="isOpen"
    :persistent="persistent"
    :width="isMobile ? 343 : 600"
    @keydown.esc="clickedOutside"
    @click:outside="clickedOutside"
  >
    <v-card
      :class="{'dialog-loading': isLoading}"
      class="alert-dialog"
    >
      <i
        v-if="showCloseIcon"
        class="icon-close"
        @click="close"
      />
      <v-card-title
        v-show="title"
        class="dialog-title"
      >
        {{ title }}
      </v-card-title>
      <v-card-text
        v-show="message || messageHTML || isLoading"
        class="dialog-content"
      >
        {{ message }}
        <div v-html="messageHTML" />
        <div class="loading">
          <v-progress-circular
            v-if="isLoading"
            indeterminate
            color="primary"
          />
        </div>
      </v-card-text>
      <v-card-actions
        class="alert-actions"
        :class="{ 'has-left-btn': leftBtn.length > 0 }"
      >
        <template v-if="leftBtn.length > 0">
          <v-btn
            v-for="(leftBtnItem, index) in leftBtn"
            :key="'left-' + index"
            :ref="'alertDialogLeftBtn-' + index"
            :color="leftBtnItem.btnColor"
            :loading="leftBtnItem.btnIsLoading"
            :small="isMobile"
            :text="leftBtnItem.text"
            class="alert-left-btn"
            :class="{ 'alert-left-btn--text': leftBtnItem.text }"
            :depressed="!leftBtnItem.text"
            @click="leftBtnItem.btnClick($event)"
          >
            {{ leftBtnItem.btnText }}
          </v-btn>
        </template>
        <v-spacer v-if="leftBtn.length > 0" />
        <template v-if="btn.length > 0">
          <div
            v-if="btn.length > 1"
            class="btn-group"
          >
            <v-btn
              v-for="(btnItem, index) in btn"
              :key="index"
              :ref="'alertDialogBtn-' + index"
              :color="btnItem.btnColor"
              :loading="btnItem.btnIsLoading"
              :small="isMobile"
              class="alert-btn"
              depressed
              @click="btnItem.btnClick($event)"
            >
              {{ btnItem.btnText }}
            </v-btn>
          </div>
          <v-btn
            v-else
            :ref="'alertDialogBtn-0'"
            :color="btn[0].btnColor"
            :loading="btn[0].btnIsLoading"
            :small="isMobile"
            class="alert-btn"
            depressed
            @click="btn[0].btnClick($event)"
          >
            {{ btn[0].btnText }}
          </v-btn>
        </template>
        <v-btn
          v-else-if="!noBtn"
          color="primary"
          class="btn"
          @click="close(true)"
        >
          {{ btnText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['isMobile']),
    isOpen () {
      return this.$store.state.alert.open
    },
    title () {
      return this.$store.state.alert.title
    },
    message () {
      return this.$store.state.alert.message
    },
    messageHTML () {
      return this.$store.state.alert.messageHTML
    },
    persistent () {
      return this.$store.state.alert.persistent
    },
    btnText () {
      return this.$store.state.alert.btnText
    },
    btnDonFun () {
      return this.$store.state.alert.btnDonFun
    },
    btn () {
      return this.$store.state.alert.btn
    },
    leftBtn () {
      return this.$store.state.alert.leftBtn
    },
    isLoading () {
      return this.$store.state.alert.isLoading
    },
    noBtn () {
      return this.$store.state.alert.noBtn
    },
    clickOutside () {
      return this.$store.state.alert.clickOutside
    },
    showCloseIcon () {
      return this.$store.state.alert.showCloseIcon
    }
  },
  methods: {
    open () {
      console.log('open')
    },
    clickedOutside () {
      if (typeof this.clickOutside === 'function') {
        this.clickOutside()
        return
      }
      if (this.persistent) return
      this.close(false)
    },
    close (status) {
      if (this.btnDonFun) {
        this.btnDonFun(status)
      } else {
        this.$store.dispatch('alert/close')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.alert-dialog {
  padding: 20px;
}

.loading {
  display: flex;
  justify-content: center;
}

.dialog-loading {
  .dialog-title {
    text-align: center;
    justify-content: center;
    padding-inline: 40px;
  }
  .dialog-content {
    text-align: center;
    padding: 20px;
  }
}

.v-card {
  position: relative;
  &__title.dialog-title {
    @include font('title-large');
    padding: 0;
    margin-bottom: 4px;
    line-height: initial;
  }

  &__text.dialog-content {
    @include font('caption-small');
    padding: 0;
    color: $color-text-primary;
  }

  &__actions {
    &.alert-actions {
      padding: 0;
      margin-top: 34px;
      display: flex;
      justify-content: flex-end;
      &.has-left-btn {
        justify-content: space-between;
      }
    }
    .alert-left-btn {
      margin-left: -8px;
      &.alert-left-btn--text {
        margin-left: -8px;
      }
    }
    .btn-group {
      display: flex;
    }
    .alert-btn {
      min-width: 66px;
      + .alert-btn {
        margin-left: 12px;
      }
    }
  }
  .icon-close {
    @include font('title');
    position: absolute;
    top: 22px;
    right: 20px;
    cursor: pointer;
  }
}

@media screen and (min-width: $mobileWidth) {
  .v-card {
    &__title.dialog-title {
      @include font('heading3');
      margin-bottom: 8px;
    }
    &__text.dialog-content {
      @include font('body');
    }
    &__actions {
      &.alert-actions {
        margin-top: 55px;
      }
      .alert-btn {
        min-width: 84px;
        padding: 0 24px;
      }
    }
  }
}
</style>
